import { render, staticRenderFns } from "./AddCourseOrExam.vue?vue&type=template&id=1bdcac05&"
import script from "./AddCourseOrExam.vue?vue&type=script&lang=js&"
export * from "./AddCourseOrExam.vue?vue&type=script&lang=js&"
import style0 from "./AddCourseOrExam.vue?vue&type=style&index=0&id=1bdcac05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports